var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBoutiqueIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 35.372
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3428"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFC72C",
  d: "M24 12.006A12 12 0 1 0 5.477 22.072l6.524 13.3 6.524-13.3A11.98 11.98 0 0 0 24 12.006M12 4.977a7.029 7.029 0 1 1-7.028 7.029 7.03 7.03 0 0 1 7.029-7.029Z",
  "data-name": "Path 3963"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7.445,
  cy: 7.445,
  r: 7.445,
  fill: "#0e2240",
  "data-name": "Ellipse 676",
  transform: "translate(4.533 4.542)"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ffc72c",
  d: "M12.806 11.261c-.249-.157 0-.392.227-.392a1.2 1.2 0 0 1 .709.332s-.643.246-.936.06m-3.454 3.312c-.859.236-.631-1.7.46-3.242a6.9 6.9 0 0 1 1.984-2.046c-.188 2.3-1.527 5.036-2.443 5.288m5.353-6.244a2.74 2.74 0 0 0-2.027.132 2.95 2.95 0 0 0-.1-1.286l-.8.231a6.7 6.7 0 0 1 .054 1.47 8.96 8.96 0 0 0-3.89 4.711c-.424 1.52.758 2.036 1.752 1.288 2.452-1.853 2.95-6.053 2.95-6.053a1.71 1.71 0 0 1 1.675.2c.869.768-.259 1.948-.259 1.948a1.3 1.3 0 0 0-.841-.4c-.879-.081-1.326 1-.159 1.118a2.5 2.5 0 0 0 .906-.155 2.34 2.34 0 0 1-.993 2.594c-1.014.456-1.391-.184-1.391-.184a3.2 3.2 0 0 0-.518.76 1.48 1.48 0 0 0 1.716.47 2.67 2.67 0 0 0 1.615-1.705 2.53 2.53 0 0 0-.043-2.1c1.545-1.106 1.319-2.61.351-3.037",
  "data-name": "Path 3964"
})));
export { SvgBoutiqueIcon as ReactComponent };
export default "/_next/static/images/boutique-icon.svg";